var map = {
	"./QS420/QS420.less": 457,
	"./QS421/QS421.less": 543
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile ^\.\/.*\.less$
// module id = 1308
// module chunks = 2